/**
 * Download csv file
 * @param {String} csv - csv contents
 * @param {String} filename - name of file
 */
export const downloadCSV = (csv, filename) => {
  const csvFile = new Blob([csv], { type: 'text/csv' });
  let downloadLink = document.createElement('a');

  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);

  downloadLink.click();
};
